export const darkColors = `
  <style>
    [theme="dark"] {

      --white-layout-300-primary: #FFFFFF;
      --white-layout-301-level-0-elevation: #0E131A;
      --white-layout-302-level-1-elevation: #191D24;
      --white-layout-303-level-2-elevation: #20252B;
      --white-layout-304-text: #ffffffcc;
      --white-layout-305-disabled-text: #ffffff80;
      --white-layout-306-primary-hc: #FFFFFF;
      --white-layout-200-secondary: #000000e6;
      --white-layout-302-active-focus: #349DF726;
      --white-layout-201-secondary-on-dark-background: #ffffffe6;
      --white-layout-250-disabled-text-on-blue-background: #ffffffa6;
      --white-layout-100-disabled: #ffffffe6;
      --white-layout-101-outline-on-dark-background: #ffffff73;
      --white-layout-050-hover-on-dark-background: #ffffff26;
      --white-layout-010-hover-primary: #ffffff1f;
      --white-layout-011-hover-on-blue-background: #ffffff14;
      --white-layout-012-hover-on-blue-background: #ffffff0d;
      --white-layout-005-background-for-icon-menu: #ffffff14;
      --white-layout-001-hover-on-blue-background: #ffffff14;
      --white-layout-002-light-background-on-dark-theme: #ffffff08;

      --grey-layout-020-side-panel-background: #191D24;
      --grey-layout-500-neutral-background: #ffffffcc;
      --grey-layout-501-neutral-background: #3C3C3C;
      --black-layout-700-primary: #FFFFFF;
      --black-layout-701-primary: #000000;

      --main-titles-inputs-600: #ffffffe6;
      --main-titles-inputs-601: #FF0000;
      --main-titles-inputs-602: #ffffff66;
      --main-titles-inputs-603: #000000e6;

      --body-text-arrows-400: #ffffffcc;
      --body-text-arrows-401: #000000b3;

      --chart-300-icon-buttons: #ffffffa6;
      --chart-301-icon-buttons: #ffffffe6;
      --chart-302-icon-buttons-titles: #ffffff80;
      --chart-303-icon-buttons-titles: #ffffff26;
      --chart-304-icon-buttons: #00000099;
      --chart-305-icon-buttons: #000000cc;

      --grey-layout-200-disabled: #ffffff80;
      --grey-layout-201-disabled-text: #00000073;
      --grey-layout-202-disabled-icons: #ffffff33;
      --grey-layout-203-dark-theme-disabled-text: #ffffff59;

      --chart-100-pressed: #ffffff40;
      --chart-101-pressed-dividers: #ffffff14;
      --chart-102-pressed: #ffffff0a;
      --chart-103-pressed: #fff0;
      --chart-104-pressed: #ffffff26;
      --chart-105-solid: #C2C2C2;

      --chart-050-hover: #ffffff0f;
      --chart-051-hover: #ffffff33;
      --chart-052-graph-background: #0E131A;

      --blue-layout-500-focus: #B3D3FF;
      --blue-layout-501-focus: #065CC1;
      --blue-layout-502-focus: #B3D3FF;
      --blue-layout-503-focus-on-dark-background-hc: #B3D3FF;
      --blue-layout-504-focus-on-dark-background-light-theme: #B3D3FF;

      --blue-layout-400-primary: #88BBFF;
      --blue-layout-401-primary: #FF0000;
      --blue-layout-402-primary-background: #0064EA;
      --blue-layout-403-primary: #006DFF;
      --blue-layout-404-primary: #004CB1;
      --blue-layout-405-primary-hc-on-light-background: #A8CDFF;

      --blue-layout-300-active: #8CCAFF;
      --blue-layout-301-active: #349DF7;
      --blue-layout-302-active-focus: #349DF726;
      --blue-layout-303-active: #349DF780;
      --blue-layout-304-active: #006DFF;
      --blue-layout-305-active: #349DF726;
      --blue-layout-306-active: #8CCAFF;
      --blue-layout-307-active-hc: #8CCAFF;
      --blue-layout-308-active-hc: #349DF7;

      --blue-layout-200-disabled: #ffffff0d;
      --blue-layout-201-disabled: #006eff4d;
      --blue-layout-202-disabled: #e5f3ff99;
      --blue-layout-203-disabled: #91befdb3;

      --blue-layout-100-background: #13151b99;
      --blue-layout-101-background: #ffffff1f;
      --blue-layout-102-background: #006eff26;
      --blue-layout-103-background: #d6e9ff1f;
      --blue-layout-104-solid-background: #262C35;

      --blue-layout-050-selected: #ffffff1a;
      --blue-layout-051-selected: #ffffff33;

      --dark-blue-700-main-menu: #090E13;
      --dark-blue-701-main-menu-dark-background: #ffffff1a;
      --dark-blue-702-main-menu: #20252B;
      --dark-blue-703-main-menu: #ffffff33;

      --dark-blue-600-secondary-menu: #202C3D;

      --red-layout-001-logo: #FF0000;
      --red-layout-300-primary: #EC5B62;
      --red-layout-301-primary: #FF5B63;
      --red-layout-302-primary: #D54143;
      --red-layout-303-primary: #FF767D;
      --red-layout-200-hover: #ec5b6299;
      --red-layout-201-hover: #EC5B624D;
      --red-layout-100-disabled: #ec5b624d;
      --red-layout-101-disabled: #ef6b72b3;
      --red-layout-102-disabled: #EC5B6226;
      --red-layout-050-background: #ec5b620d;
      --red-layout-051-background: #EC5B6233;

      --green-layout-100-primary-green: #1F8463;
      --green-layout-101-primary-green: #65C5A6;
      --green-layout-102-primary-green-hc: #1F8463;
      --green-layout-050-secondary-green: #1f8462b3;

      --orange-layout-050-warning: #F8A94B;
      --yellow-layout-200-text-highlight: #FFD23D;
      --red-alert-chart-700-critical: #922227;
      --red-alert-500-severe: #E90A0A;
      --orange-alert-chart-100: #EF6E45;
      --yellow-alert-050: #EEDC36;
      --green-pastel-alert-chart-050-healty: #A2D179;

      --gradient-400-main-blue: #c2d1ea33;
      --gradient-401-main-blue: #c2d1eab3;

      --gradient-300-light-main-blue: #c5d4ec33;
      --gradient-301-light-main-blue: #c5d4ecb3;

      --gradient-200-secondary-blue: #d1dcf033;
      --gradient-201-secondary-blue: #d1dcf0b3;

      --gradient-100-light-secondary-blue: #e7eef833;
      --gradient-101-light-secondary-blue: #e7eef8b3;

      --gradient-050-light-blue: #f6fafd33;
      --gradient-051-light-blue: #f6fafdb3;

      --gradient-010-very-light-blue: #fcfcfc33;
      --gradient-011-very-light-blue: #fcfcfcb3;

      --grey-layout-chart-100: #ffffff1f;
      --red-chart-600: #F02A42;
      --red-chart-400: #EF5350;
      --yellow-chart-050: #FFB74D;
      --green-chart-050: #00CC66;

      --green-teal-chart-400: #007065;
      --green-teal-chart-300: #269588;
      --green-teal-chart-200: #00A19B;
      --green-teal-chart-100: #00BBB4;
      --green-teal-chart-050: #00CCBD;

      --teal-chart-400: #1B8AA8;
      --teal-chart-300: #2898B2;
      --teal-chart-200: #35A9BC;
      --teal-chart-100: #44BAC6;
      --teal-chart-050: #74D6DB;

      --blue-chart-500: #295CA5;
      --blue-chart-400: #366EB2;
      --blue-chart-300: #4480BC;
      --blue-chart-200: #5493C6;
      --blue-chart-100: #65A6D1;
      --blue-chart-050: #67B7DC;

      --sky-blue-chart-050: #3AA1CC;
      --indigo-blue-chart-050: #6771DC;
      --purple-chart-050: #A367DC;

      --focus-bg-color: #349DF726;
      --background-transparent: #fff0;

    /*--------------------------GZ-DATE-PICKER---------------------------------*/
      --gz-datepicker-hovered-cell-color: #252D35;
    /*-------------------------VAADIN-GRID---------------------------------*/
      --reorder-ghost-background: #F2F2F2;
    /*--------------------------GZ-LOADER---------------------------------*/
      --gz-loader-background: #ffffff40;
      --gz-loader-animation-bg: #2C3137;
    /*--------------------------GZ-PHONE-INPUT---------------------------------*/
    --gz-phone-input-border-color: #4a4e54;
    }
  </style>
`;
